export default __webpack_public_path__ + "static/media/RPG_9.d29f0126.png";